import { CellClassParams, ICellRendererParams } from 'ag-grid-enterprise'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { ManagementReport } from '@fortem-monorepo/web-sdk'

import { useManagementReportQuery } from '@/pages/funds/management-report/query'
import { ManagementReportWidget } from '@/pages/funds/management-report/types'

export interface AttributionsGridProps extends ManagementReportWidget {}

export const AttributionsGrid: React.FC<AttributionsGridProps> = ({ params }) => {
  const query = useManagementReportQuery(params)

  return (
    <Widget>
      <WidgetHeaderWithQuery query={query} title="Attributions" />
      <WidgetContent loading={query.isLoading}>
        <CustomAgGrid
          query={query}
          rowData={query.data?.attributions}
          columnDefs={makeColDefs()}
          grandTotalRow={'bottom'}
          statusBar={{ statusPanels: [] }}
        />
      </WidgetContent>
    </Widget>
  )
}

const boldCellRules = {
  ['font-medium']: (params: CellClassParams) => {
    return params.node.level === -1
  },
}

const makeColDefs = () => {
  return createColDefs<Required<ManagementReport.GetManagementReportData>['attributions'][number]>([
    {
      field: 'investment_bucket',
      headerName: 'Bucket',
      cellClassRules: boldCellRules,
      cellRenderer: (params: ICellRendererParams) => {
        return params?.node.level === -1 ? 'Total' : params.value
      },
    },
    {
      field: 'ytd_attributions',
      headerName: 'YTD Attributions',
      cellClassRules: boldCellRules,
      cellClass: 'text-center',
      valueFormatter: numberFormatter({
        suffix: '%',
        transformer(val) {
          return val * 100
        },
      }),
      aggFunc: 'sum',
    },
  ])
}
